<app-widget widgetTitle="notifications.unread_notifications" [loader]="loading$ | async">
  <div content>
    <app-notifications class="adloop-scrollbar"
                       appScrollTopBottom
                       [withHeader]="false"></app-notifications>
  </div>
</app-widget>
